module.exports = __webpack_public_path__ + "img/ed-card-illustration-grey.0cc19fcd.png";